<template>
  <nav id="UiLayer">
      <Logo></Logo>
      <Home v-if="!onHomePage"></Home>
      <!-- <Breadcrumbs></Breadcrumbs> -->
  </nav>
</template>
<script>
import Logo from "../ui/Logo.vue";
import Home from "../ui/Home.vue";
import Breadcrumbs from "../ui/Breadcrumbs.vue";

export default {
  components: {
    // Ui Components
    Logo,
    Breadcrumbs,
    Home,
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    onHomePage() {
      this.$route;
      return app.api.PageManager.onHomePage();
    }
  }
};
</script>

<style lang="scss">
#UiLayer {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  * {
    pointer-events: all;
  }
}
</style>